export default __webpack_public_path__ + "images/MPSVR-SR-logo.svg";